module.exports = __webpack_public_path__ + "static/4-2-x@2x-23fd656b0cfc81af4f528b5f188080ba.png";